import { AfterContentInit, Component, ElementRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';
import { detect } from 'detect-browser';
import { authConfig } from 'src/environments/environment';
import { NavMenuComponent } from './components/nav-menu/nav-menu.component';
import { ENavigationErrorType } from './model/enum/navigation-error-type';
import { ENavigationRoute } from './model/enum/navigation-route';
import { CoreData } from './tools/core-data/core-data';
import { NgcCookieConsentService, NgcStatusChangeEvent } from 'ngx-cookieconsent';
import { Subscription } from 'rxjs';
import { AppConfig } from './app.config';

const browser = detect();

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
})
export class AppComponent implements AfterContentInit {
    @ViewChild(NavMenuComponent) menu!: NavMenuComponent;
    @ViewChild('tata', { read: ElementRef }) mainContainer!: ElementRef;
    title = 'EOL';
    PageHeight: string = '';
    Overflow: string = 'auto';
    private statusChangeSubscription!: Subscription;

    constructor(

        private config: AppConfig,
        private oauthService: OAuthService,
        private route: ActivatedRoute,
        private ccService: NgcCookieConsentService,
        private router: Router,
        private coreData: CoreData) {
        // this.coreData.Token = 'W3siTmFtZSI6IkNhblBsYW5JbnRlcnZlbnRpb24ifSx7Ik5hbWUiOiJDYW5DcmVhdGVNZXN1cmVDb21wbGVtZW50YWlyZSJ9LHsiTmFtZSI6IkNhblJlYWRJbnRlcnZlbnRpb24ifSx7Ik5hbWUiOiJDYW5SZWFkRGF0YVJlcG9zaXRvcnkifV0='
    }

    ngAfterContentInit(): void {
        this.PageHeight = `calc(100% - 80px)`;
        this.Overflow = 'auto';

        if (browser && browser.name === 'ie') {
            this.router.navigate([ENavigationRoute.Error, { type: ENavigationErrorType.IE }]);
        }
        let params = new URLSearchParams(window.location.search);
        let withPromptLogin = Boolean(params.get('promptLogin'));

        this.configureOauth2(withPromptLogin);

        this.statusChangeSubscription = this.ccService.statusChange$.subscribe(
            (event: NgcStatusChangeEvent) => {
                console.log(`statusChangeSubscription: ${event}`);
                // if (event.status === 'allow') {
                //     this.matomoTracker.setConsentGiven();
                //     this.matomoTracker.rememberConsentGiven();
                // } else if (event.status === 'dismiss' || event.status === 'deny') {
                //     this.matomoTracker.forgetConsentGiven();
                // }
                // you can use this.ccService.getConfig() to do stuff...
            });

    }

    async configureOauth2(withPromptLogin: boolean) {

        authConfig.issuer = this.config.getConfig('issuer')
        authConfig.tokenEndpoint = this.config.getConfig('tokenEndpoint')
        authConfig.redirectUri = `${this.config.getConfig('redirectUri')}`
        authConfig.revocationEndpoint = this.config.getConfig('revocationEndpoint')
        authConfig.clientId = this.config.getConfig('clientId')
        authConfig.scope = this.config.getConfig('scope')
        authConfig.responseType = this.config.getConfig('responseType')
        authConfig.oidc = this.config.getConfig('oidc') 

        if (withPromptLogin) {
            authConfig.customQueryParams = {
                'prompt': 'login',
            };
        }

        this.oauthService.configure(authConfig);
        let opt = undefined;
        await this.oauthService.loadDiscoveryDocumentAndTryLogin(opt);
    }

    updateHeight(event: string) {
        this.Overflow = 'hidden';
        setTimeout(() => {
            this.PageHeight = `calc(100% - ${event})`;
            this.Overflow = 'auto';
        }, 0);
    }
}
